import { CUSTOMERS } from "../../data/adminData";
import { fmt } from "../../data/store";

export default function Customers() {
  return (
    <div data-testid="admin-customers">
      <h1 className="text-2xl font-extrabold uppercase tracking-tight mb-5">Klienti ({CUSTOMERS.length})</h1>
      <div className="bg-white border border-[#E2E2E2] overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead><tr className="text-left text-xs uppercase tracking-wider text-[#6B6B6B] border-b border-[#E2E2E2]">
            <th className="p-3">Klients</th><th>Uzņēmums</th><th>Kontakti</th><th className="text-center">Tips</th><th className="text-center">Pasūtījumi</th><th className="text-right">Apgrozījums</th>
          </tr></thead>
          <tbody>
            {CUSTOMERS.map((c) => (
              <tr key={c.id} className="border-b border-[#F5F5F5] hover:bg-[#F5F5F5]" data-testid={`customer-row-${c.id}`}>
                <td className="p-3 font-bold">{c.name}</td>
                <td className="text-[#6B6B6B]">{c.company || "Privātpersona"}</td>
                <td className="text-[#6B6B6B]">{c.email}<div className="text-xs">{c.phone}</div></td>
                <td className="text-center"><span className={`text-[11px] font-bold px-2 py-0.5 ${c.type === "B2B" ? "bg-[#111111] text-white" : "bg-[#E2E2E2]"}`}>{c.type}</span></td>
                <td className="text-center">{c.orders}</td>
                <td className="text-right font-bold">{fmt(c.spent)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
